import axios from "axios";
import React, { useEffect, useState } from "react";
import { MdOutlineWatchLater } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppointmentList } from "../reduxtool/action";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import AppointmentDetailModal from "./AppointmentDetailModal";
import '../ScrollBar/ScrollBar.css'

import ReceiptModal from "./ReceiptModal";

 const MyAppointments = () => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();

  const AppointmentList = useSelector(
    (state: any) => state.patientAppointmentList
  );
  const patientProfile = useSelector(
    (state: any) => state.userDetails
  );

const [selectedAppointment, setSelectedAppointment] = useState<any | null>(null);
  const [openAppointmentTab, setAppointmentTab] = useState("Upcomming");
  const [statusFilter, setStatusFilter] = useState<string>("All");
const [selectedReceipt, setSelectedReceipt] = useState<any | null>(null);

  const handleUpcomming = () => {
    setAppointmentTab("Upcomming");
  };

  const handlePast = () => {
    setAppointmentTab("Past");
  };
 const filteredUpcomingAppointments = AppointmentList?.upcomingAppointments?.filter((appointment: any) =>
    statusFilter === "All" ? true : appointment.flag === statusFilter
  );

  const filteredPastAppointments = AppointmentList?.pastAppointments?.filter((appointment: any) => {
    const slotEndTime = new Date(`${appointment.appointmentDate}T${appointment.slotEndTime}`);
    const now = new Date();

    let displayFlag = appointment.flag;
    if ((appointment.flag === "A" || appointment.flag === "S") && slotEndTime < now) {
      displayFlag = "M";
    }

    return statusFilter === "All" ? true : displayFlag === statusFilter;
  });

  useEffect(()=>{
    const isAppointmentsEmpty =
    !AppointmentList || Object.keys(AppointmentList).length===0;
    if (isAppointmentsEmpty){
      dispatch(setAppointmentList());
    }
  }, [dispatch, AppointmentList]);

const handlePatientPrescription = (appointment: any) => {
      setSelectedAppointment(appointment);
};
const handleReceipt=(appointment:any)=>{
setSelectedReceipt(appointment);
}

 const getAge = (dob: string) => {
    if (!dob) return "N/A";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age.toString();
  };

  const patientInfo = {
    name: patientProfile?.patientName || "N/A",
    gender:
      patientProfile?.gender === "M"
        ? "Male"
        : patientProfile?.gender === "F"
        ? "Female"
        : "Other",
    age: patientProfile?.dob ? getAge(patientProfile.dob) : "N/A",
 
  };

  return (
    <div className="px-1 xs:px-5 bg-white">
    {selectedReceipt && (
        <ReceiptModal
          appointment={selectedReceipt}
          patientInfo={patientInfo}
          patientProfile={patientProfile}
          onClose={() => setSelectedReceipt(null)}
        />
      )}

{selectedAppointment && (
  <AppointmentDetailModal
     appointment={{
  
         appointmentId: selectedAppointment.appointmentId,
            name: selectedAppointment.patientName || "N/A",
            specialty: selectedAppointment.specializationName,
            date: selectedAppointment.formatedDate,
            time: selectedAppointment.formatedTime,
            doctorName: selectedAppointment.doctorName,
            doctorFees: selectedAppointment.doctorFees,
              openAppointmentTab:openAppointmentTab,
              flag :selectedAppointment.flag, 
            remarks: selectedAppointment.remarks||"No remarks available",
    }}

    onClose={() => setSelectedAppointment(null)}
  />
)}
      <div className="xs:px-2 bg-white  text-black text-lg sm:text-xl md:text-2xl font-medium">
        My Appointments
      </div>
      <div className="flex justify-center w-full">
        <div className=" w-full xs:w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%]">
          <div className="flex justify-end items-center gap-5   bg-white py-2">
             <div className="relative inline-block">
  <select
    className="px-4 py-2 pr-8 rounded-md text-[12px] text-[#009A85]  focus:outline-none focus:ring-0 border-none appearance-none shadow-sm shadow-gray-400"
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
  >
    <option className="text-black" value="All">All Statuses</option>
    <option className="text-black" value="A">Confirmed</option>
    <option className="text-black" value="S">Scheduled</option>
    <option className="text-black" value="M">Missed</option>
    <option className="text-black" value="C">Cancelled</option>
    <option className="text-black" value="D">Completed</option>
    <option className="text-black" value="R">Rescheduled</option>
  </select>

  {/* Custom arrow icon */}
  <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-[#009A85] text-sm">
    ▾
  </div>
</div>
            <button
              className="bg-[#009A85] py-1 px-3 text-white rounded-lg text-[15px] font-semibold"
              onClick={() => {
                navigate("/doctors");
              }}
            >
              New Appointment
            </button>
            {/* <div className="border border-1 border-black rounded-lg p-1">
  <CiFilter className="text-[20px]"/>
  </div> */}
          </div>
          <div className="border border-1 rounded-lg ">
            <div className="flex w-full text-[15px] font-medium bg-white rounded-t-lg shadow-md">
  {/* Upcoming Tab */}
  <div
    className={`flex justify-center items-center gap-2 w-1/2 p-3 rounded-t-lg transition-all duration-300 cursor-pointer ${
      openAppointmentTab === "Upcomming"
        ? "bg-[#009A85] text-white shadow-md"
        : "bg-[#E0E0E0] text-gray-700 hover:bg-[#D5D5D5]"
    }`}
    onClick={handleUpcomming}
  >
    <MdOutlineWatchLater className="text-lg" />
    <p className="truncate">Upcoming Appointments</p>
  </div>

  {/* Past Tab */}
  <div
    className={`flex justify-center items-center gap-2 w-1/2 p-3 rounded-t-lg transition-all duration-300 cursor-pointer ${
      openAppointmentTab === "Past"
        ? "bg-[#184A84] text-white shadow-md"
        : "bg-[#E0E0E0] text-gray-700 hover:bg-[#D5D5D5]"
    }`}
    onClick={handlePast}
  >
    <TiTick className="text-lg" />
    <p className="truncate">Past Appointments</p>
  </div>
</div>

            {/*}  */}

            <div
              className="overflow-y-auto custom-scrollbar"
              style={{ height: "calc(100vh - 300px)" }}
            >
              {openAppointmentTab === "Upcomming" &&
                (filteredUpcomingAppointments?.length > 0 ? (
                 filteredUpcomingAppointments?.map(
                    (appointment: any) => (
                      <div
                        key={""}
                        className="grid grid-cols-3 gap-2 bg-[#009A850D]  xs:p-3  mx-2 p-3 xs:mx-4 mt-2 rounded-lg"
                      >
                        <div>
                          <p className="font-semibold text-[12px] truncate">
                            {appointment.doctorName}
                          </p>
                          <p className="text-[#606060] text-[12px] mt-2">
                            {appointment.specializationName}
                          </p>
                        </div>
                        <div className="flex  justify-center">
                          <div className="flex flex-col text-start">
                            <p className="font-semibold text-[12px]">
                              {appointment.formatedDate},{" "}
                              {appointment.formatedTime}
                            </p>
                            <button
      className="bg-[#184A84] text-white px-2 py-1 text-[12px] rounded-lg"
      onClick={() => handleReceipt(appointment)}
    >
    Invoice
    </button>
                          </div>
                        </div>
                        <div className="flex  justify-end">
                          <div className="flex flex-col text-end">
                           <button
                              className={`p-1 px-2 text-[10px] rounded-lg border ${  appointment.flag === "S"
                                  ? "bg-[#00C85333] text-[#00C853] border border-[#00C853]":
    appointment.flag === "A" 
      ? "bg-[#E6F4EA] text-[#2E7D32] border-[#A5D6A7]"           // Confirmed
      : appointment.flag === "Pending"
      ? "bg-[#FFF8E1] text-[#F9A825] border-[#FFEE58]"           // Pending
      : appointment.flag === "M"
      ? "bg-[#FDECEA] text-[#D32F2F] border-[#EF9A9A]"           // Missed
      : appointment.flag === "R"
      ? "bg-[#E3F2FD] text-[#1565C0] border-[#90CAF9]"           // Rescheduled
      : appointment.flag === "D"
      ? "bg-[#E8F5E9] text-[#388E3C] border-[#A5D6A7]"           // Completed
      : appointment.flag === "C"
      ? "bg-[#FBE9E7] text-[#C62828] border-[#EF9A9A]"           // Cancelled
      : "bg-[#ECEFF1] text-[#546E7A] border-[#B0BEC5]"           // Unknown/fallback
  }`}
>
  {appointment.flag === "A"  
    ? "Confirmed"
    :appointment.flag === "S"
    ?"Scheduled":
     appointment.flag === "Pending"
    ? "Pending"
    : appointment.flag === "M"
    ? "Missed"
    : appointment.flag === "R"
    ? "Rescheduled"
    : appointment.flag === "D"
    ? "Completed"
    : appointment.flag === "C"
    ? "Cancelled"
    : appointment.flag}
                            </button>

                            {/* <p className="text-[#606060] text-[12px]">
                              Charges: ₹{appointment.doctorFees}
                            </p> */}
                          
  <button
    className="bg-[#009A85] text-white px-2 py-1 text-[12px] rounded-lg mt-1"
    onClick={() => handlePatientPrescription(appointment)}
  >
    View Details
  </button>

                          
                          </div>
                        </div>
                      </div>
                    )
                  )
                ) : (
                  <div className="flex justify-center items-center h-[300px]">
                    <div className="text-center text-[#606060]">
                      <p className="text-lg font-semibold">
                        You don’t have any upcoming appointments!
                      </p>
                      <p className="text-sm mt-1">
                        Book an appointment now to stay on top of your health.
                      </p>
                      <Link to="/doctors">
                        <button className="bg-[#009A85] text-white px-5 py-2 rounded-lg mt-4 hover:bg-[#007a68] transition-all  shadow-sm shadow-gray-400">
                          Book Appointment
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}

              {openAppointmentTab === "Past" &&
                (filteredPastAppointments?.length > 0 ? (
               filteredPastAppointments?.map((appointment: any, index: any) => {
 const slotEndTime = new Date(`${appointment.appointmentDate}T${appointment.slotEndTime}`);
  const now = new Date();

  let displayFlag = appointment.flag;
      if ((appointment.flag === "S" || appointment.flag === "A") && slotEndTime < now) {
        displayFlag = "M";
      }

  return (
    <div
      key={index}
      className="grid grid-cols-3 gap-2 bg-[#F9F9F9] xs:p-3 mx-2 p-3 xs:mx-4 mt-2 rounded-lg"
    >
      <div>
        <p className="font-semibold truncate text-[12px]">{appointment.doctorName}</p>
        <p className="text-[#606060] text-[12px] mt-2">
          {appointment.specializationName}
        </p>
      </div>
      
      <div className="flex  justify-start xs:ml-10">
        <div className="flex flex-col ">
          <p className="font-semibold text-[12px]">
            {appointment.formatedDate}, {appointment.formatedTime}
          </p>
         
  <div className="flex flex-col gap-1 mt-2">
    
    <button
      className="bg-[#184A84] text-white px-2 py-1 text-[12px] rounded-lg"
      onClick={() => handleReceipt(appointment)}
    >
    Invoice
    </button>
  </div>
        </div>
      </div>

      <div className="flex justify-end">
        <div className="flex flex-col text-end">
          <button
            className={`p-1 px-2 text-[10px] rounded-lg border ${
                  displayFlag === "S"
                    ? "bg-[#00C85333] text-[#00C853] border border-[#00C853]"
                    : displayFlag === "A"
                    ? "bg-[#E6F4EA] text-[#2E7D32] border-[#A5D6A7]"
                    : displayFlag === "Pending"
                    ? "bg-[#FFF8E1] text-[#F9A825] border-[#FFEE58]"
                    : displayFlag === "M"
                    ? "bg-[#FDECEA] text-[#D32F2F] border-[#EF9A9A]"
                    : displayFlag === "R"
                    ? "bg-[#E3F2FD] text-[#1565C0] border-[#90CAF9]"
                    : displayFlag === "D"
                    ? "bg-[#E8F5E9] text-[#388E3C] border-[#A5D6A7]"
                    : displayFlag === "C"
                    ? "bg-[#FBE9E7] text-[#C62828] border-[#EF9A9A]"
                    : "bg-[#ECEFF1] text-[#546E7A] border-[#B0BEC5]"
                }`}
              >
                {
                  displayFlag === "A"
                    ? "Confirmed"
                    : displayFlag === "S"
                    ? "Scheduled"
                    : displayFlag === "M"
                    ? "Missed"
                    : displayFlag === "R"
                    ? "Rescheduled"
                    : displayFlag === "D"
                    ? "Completed"
                    : displayFlag === "C"
                    ? "Cancelled"
                    : displayFlag
                }
          </button>
          {/* <p className="text-[#606060] text-[14px]">
            Charges: ₹{appointment.doctorFees}
          </p> */}
          
  <button
    className="bg-[#009A85] text-white px-2 py-1 text-[12px] rounded-lg mt-1"
    onClick={() => handlePatientPrescription(appointment)}
  >
    View Details
  </button>

        </div>
      </div>
    </div>
  );
})

                ) : (
                  <div className="flex justify-center items-center h-[300px]">
                    <div className="text-center text-[#606060]">
                      <p className="text-lg font-semibold">
                        You don’t have any Past appointments!
                      </p>
                      <p className="text-sm mt-1">
                        Book an appointment now to stay on top of your health.
                      </p>
                      <Link to="/doctors">
                        <button className="bg-[#009A85] text-white px-5 py-2 rounded-lg mt-4 hover:bg-[#007a68] transition-all  shadow-sm shadow-gray-400">
                          Book Appointment
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MyAppointments;
